import { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'hooks/useQuery';

interface IParams {
  caseId?: string;
}

type TProps = {
  notifications: any[];
  markNotificationsAs: (notis: any[], isViewed: boolean) => Promise<void>;
};

export const useMarkedNotSuitableCaseIdAsReadIfVisited = ({ notifications, markNotificationsAs }: TProps): void => {
  const [isMarkedNotSuitableCaseIdAsRead, setIsMarkedNotSuitableCaseIdAsRead] = useState(false);
  const params: IParams = useParams();
  const queryTarget = useQuery();
  const notSuitableCaseId = useMemo(
    () => (!isMarkedNotSuitableCaseIdAsRead && queryTarget.get('target') === 'notSuitable' ? params.caseId : ''),
    [params, isMarkedNotSuitableCaseIdAsRead],
  );
  useEffect(() => {
    if (notSuitableCaseId && notifications.length > 0) {
      const foundUnreadNotification = notifications.find((n) => n.case === notSuitableCaseId && n.isViewed === false);
      markNotificationsAs([foundUnreadNotification], true);
      setIsMarkedNotSuitableCaseIdAsRead(true);
    }
  }, [notSuitableCaseId, notifications]);
};
